import React from "react";

function RowComponentForTextContent({ label, value, colourBlindMode }) {
    const getPriorityBackgroundColor = (colourBlindMode, priority) => {
        if (colourBlindMode === true) {
            switch (priority) {
                case 1:
                    return "bg-[#A2E365]";
                case 2:
                    return "bg-[#F3F38B]";
                case 3:
                    return "bg-[#D27D23]";
                default:
                    return "bg-[#C96514]";
            }
        }
        else {
            switch (priority) {
                case 1:
                    return "bg-[#00FF19]";
                case 2:
                    return "bg-[#DDFF0A]";
                case 3:
                    return "bg-[#FA632D]";
                default:
                    return "bg-[#ff3528]";
            }
        }
      };

    return (
        <>
            <div class="row">
                <div className="box-for-text-content">
                    <span className="text-content">{label}</span>
                </div>

                {label === "Name" && (
                    <div className="box">
                        <span className="text-for-tag">{value}</span>
                    </div>
                )}

                {label === "Type" && (
                    <div className="type">
                        {value === "Bug" && (
                            <>
                                <div className="type-tick-bug">
                                    <div className="box-tick">
                                        <span>
                                            <i className="fa-solid fa-check custom-check"></i>
                                        </span>
                                    </div>
                                    <span className="text-for-tick">Bug</span>
                                </div>
                                <div className="type-tick-default">
                                    <div className="box-tick"></div>
                                    <span className="text-for-tick">
                                        Default story
                                    </span>
                                </div>
                            </>
                        )}

                        {value === "Default Story" && (
                            <>
                                <div className="type-tick-bug">
                                    <div className="box-tick"></div>
                                    <span className="text-for-tick">Bug</span>
                                </div>
                                <div className="type-tick-default">
                                    <div className="box-tick">
                                        <span>
                                            <i className="fa-solid fa-check custom-check"></i>
                                        </span>
                                    </div>
                                    <span className="text-for-tick">
                                        Default story
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {label === "Story Point" && (
                    <>
                        <div className="type">
                            <div className="story-point-box">
                                <span className="text-for-story-point">
                                    {value}
                                </span>
                            </div>
                        </div>
                    </>
                )}

                {label === "Tag" && Array.isArray(value) && (
                    <div className="box">
                        {value.map((tag, index) => (
                            <span key={index} className="text-for-tag">
                                {tag}
                                {index < value.length - 1 && " "}{" "}
                                {/* Add space unless it's the last item */}
                            </span>
                        ))}
                    </div>
                )}

                {label === "Priority" && (
                    <div class="type">
                        {value === 1 && (
                            <>
                                <div class="p-type-tick-green">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 1)} colored-box-tick-green`}>
                                        <span>
                                            <i class="fa-solid fa-check"></i>
                                        </span>
                                    </div>
                                    <span class="text-for-tick">Low</span>
                                </div>

                                <div class="p-type-tick-yellow">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 2)} colored-box-tick-yellow`}></div>
                                    <span class="text-for-tick">Medium</span>
                                </div>

                                <div class="p-type-tick-orange">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 3)} colored-box-tick-orange`}></div>
                                    <span class="text-for-tick">Important</span>
                                </div>

                                <div class="p-type-tick">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 4)} colored-box-tick-red`}></div>
                                    <span class="text-for-tick">Urgent</span>
                                </div>
                            </>
                        )}

                        {value === 2 && (
                            <>
                                <div class="p-type-tick-green">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 1)} colored-box-tick-green`}></div>
                                    <span class="text-for-tick">Low</span>
                                </div>

                                <div class="p-type-tick-yellow">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 2)} colored-box-tick-yellow`}>
                                        <span>
                                            <i class="fa-solid fa-check"></i>
                                        </span>
                                    </div>
                                    <span class="text-for-tick">Medium</span>
                                </div>

                                <div class="p-type-tick-orange">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 3)} colored-box-tick-orange`}></div>
                                    <span class="text-for-tick">Important</span>
                                </div>

                                <div class="p-type-tick">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 4)} colored-box-tick-red`}></div>
                                    <span class="text-for-tick">Urgent</span>
                                </div>
                            </>
                        )}

                        {value === 3 && (
                            <>
                                <div class="p-type-tick-green">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 1)} colored-box-tick-green`}></div>
                                    <span class="text-for-tick">Low</span>
                                </div>

                                <div class="p-type-tick-yellow">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 2)} colored-box-tick-yellow`}></div>
                                    <span class="text-for-tick">Medium</span>
                                </div>

                                <div class="p-type-tick-orange">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 3)} colored-box-tick-orange`}>
                                        <span>
                                            <i class="fa-solid fa-check"></i>
                                        </span>
                                    </div>
                                    <span class="text-for-tick">Important</span>
                                </div>

                                <div class="p-type-tick">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 4)} colored-box-tick-red`}></div>
                                    <span class="text-for-tick">Urgent</span>
                                </div>
                            </>
                        )}

                        {value === 4 && (
                            <>
                                <div class="p-type-tick-green">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 1)} colored-box-tick-green`}></div>
                                    <span class="text-for-tick">Low</span>
                                </div>

                                <div class="p-type-tick-yellow">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 2)} colored-box-tick-yellow`}></div>
                                    <span class="text-for-tick">Medium</span>
                                </div>

                                <div class="p-type-tick-orange">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 3)} colored-box-tick-orange`}></div>
                                    <span class="text-for-tick">Important</span>
                                </div>

                                <div class="p-type-tick">
                                    <div class={`${getPriorityBackgroundColor(colourBlindMode, 4)} colored-box-tick-red`}>
                                        <span>
                                            <i class="fa-solid fa-check"></i>
                                        </span>
                                    </div>
                                    <span class="text-for-tick">Urgent</span>
                                </div>
                            </>
                        )}
                    </div>
                )}

                {label === "Description" && (
                    <div class="box-description">
                        <span class="text-for-tag">{value}</span>
                    </div>
                )}

                {label === "Stage" && (
                    <div class="box">
                        <span class="text-for-tag">{value}</span>
                    </div>
                )}

                {label === "Assignee" && (
                    <div class="box">
                        <span class="text-for-tag">{value}</span>
                    </div>
                )}
            </div>
        </>
    );
}

export default RowComponentForTextContent;
